// extracted by mini-css-extract-plugin
export default {"container":"CareerEssaySubmission_container__JYVbC"};